export const deepMerge = <T, T2>(obj1: T, obj2: T2) => {
    if (!obj2 || !Object.keys(obj2)?.length) {
        return obj1;
    }

    const merged = {
        ...obj1,
        ...obj2,
    };

    for (const key of Object.keys(merged)) {
        // @ts-ignore
        if (typeof merged[key] === 'object' && merged[key] !== null && !Array.isArray(merged[key])) {
            // @ts-ignore
            merged[key] = deepMerge(obj1[key], obj2[key]);
        }
    }

    return merged;
};
